<button class="accent transparent export-button" mat-flat-button appStopPropagation [matMenuTriggerFor]="exportMenu">
  <div class="export-menu">
    <span class="text"> {{'button.export.title' | translate}} </span>
    <span class="odilo-icon" aria-hidden="true">navigate_downward</span>
  </div>
  <mat-menu #exportMenu="matMenu">
    <button [dir]="textDirection" mat-menu-item class="mat-menu-item" appStopPropagation (click)="emitFormat('xlsx')">
      <span class="odilo-icon" aria-hidden="true">download</span>
      {{'excel.format.label' | translate}}
    </button>
    <button [dir]="textDirection" mat-menu-item class="mat-menu-item" appStopPropagation (click)="emitFormat('pdf')">
      <span class="odilo-icon" aria-hidden="true">download</span>
      {{'pdf.format.label' | translate}}
    </button>
  </mat-menu>
</button>

<opac-confirmation-dialog
  [acceptLabel]="'general.accept'"
  [cancelLabel]="undefined"
  [open]="showConfirmationDialog()"
  [title]="'general.information' | translate"
  (accept)="showConfirmationDialog.set(false)"
  (cancel)="showConfirmationDialog.set(false)">
  {{ 'button.export.email' | translate }}
</opac-confirmation-dialog>